import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { stratify, hierarchy } from 'd3-hierarchy';
import { MaybeKey, MaybeTitle, MaybeTooltip } from '../transform';
export function baseChannels() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var shapes = options.shapes;
  return [{
    name: 'color'
  }, {
    name: 'opacity'
  }, {
    name: 'shape',
    range: shapes
  }, {
    name: 'enterType'
  }, {
    name: 'enterDelay',
    scaleKey: 'enter'
  }, {
    name: 'enterDuration',
    scaleKey: 'enter'
  }, {
    name: 'enterEasing'
  }, {
    name: 'key',
    scale: 'identity'
  }, {
    name: 'groupKey',
    scale: 'identity'
  }, {
    name: 'label',
    scale: 'identity'
  }];
}
export function baseGeometryChannels() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [].concat(_toConsumableArray(baseChannels(options)), [{
    name: 'title',
    scale: 'identity'
  }]);
}
export function tooltip3d() {
  return [{
    type: MaybeTitle,
    channel: 'color'
  }, {
    type: MaybeTooltip,
    channel: ['x', 'y', 'z']
  }];
}
export function tooltip2d() {
  return [{
    type: MaybeTitle,
    channel: 'color'
  }, {
    type: MaybeTooltip,
    channel: ['x', 'y']
  }];
}
export function tooltip1d() {
  return [{
    type: MaybeTitle,
    channel: 'x'
  }, {
    type: MaybeTooltip,
    channel: ['y']
  }];
}
export function tooltipXd() {
  return [{
    type: MaybeTitle,
    channel: 'color'
  }, {
    type: MaybeTooltip,
    channel: ['position']
  }];
}
export function baseAnnotationChannels() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return baseChannels(options);
}
export function basePreInference() {
  return [{
    type: MaybeKey
  }];
}
export function basePostInference() {
  return [];
}
export function bandWidth(scale, x) {
  return scale.getBandWidth(scale.invert(x));
}
export function createBandOffset(scale, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var X = value.x,
    Y = value.y,
    S = value.series;
  var x = scale.x,
    y = scale.y,
    series = scale.series;
  var _options$style = options.style,
    _options$style2 = _options$style === void 0 ? {} : _options$style,
    _options$style2$bandO = _options$style2.bandOffset,
    bandOffset = _options$style2$bandO === void 0 ? series ? 0 : 0.5 : _options$style2$bandO,
    _options$style2$bandO2 = _options$style2.bandOffsetX,
    bandOffsetX = _options$style2$bandO2 === void 0 ? bandOffset : _options$style2$bandO2,
    _options$style2$bandO3 = _options$style2.bandOffsetY,
    bandOffsetY = _options$style2$bandO3 === void 0 ? bandOffset : _options$style2$bandO3;
  var isBandX = !!(x === null || x === void 0 ? void 0 : x.getBandWidth);
  var isBandY = !!(y === null || y === void 0 ? void 0 : y.getBandWidth);
  var isSeries = !!(series === null || series === void 0 ? void 0 : series.getBandWidth);
  if (!isBandX && !isBandY) return function (d) {
    return d;
  };
  return function (d, i) {
    var widthX = isBandX ? bandWidth(x, X[i]) : 0;
    var widthY = isBandY ? bandWidth(y, Y[i]) : 0;
    var f = function f() {
      return (bandWidth(series, S[i]) / 2 + +S[i]) * widthX;
    };
    var offset = isSeries && S ? f() : 0;
    var _d = _slicedToArray(d, 2),
      x0 = _d[0],
      y0 = _d[1];
    return [x0 + bandOffsetX * widthX + offset, y0 + bandOffsetY * widthY];
  };
}
export function p(d) {
  return parseFloat(d) / 100;
}
export function visualMark(index, scale, value, coordinate) {
  var X = value.x,
    Y = value.y;
  var _coordinate$getOption = coordinate.getOptions(),
    innerWidth = _coordinate$getOption.innerWidth,
    innerHeight = _coordinate$getOption.innerHeight;
  var P = Array.from(index, function (i) {
    var x0 = X[i];
    var y0 = Y[i];
    var x = typeof x0 === 'string' ? p(x0) * innerWidth : +x0;
    var y = typeof y0 === 'string' ? p(y0) * innerHeight : +y0;
    return [[x, y]];
  });
  return [index, P];
}
export function field(encode) {
  return typeof encode === 'function' ? encode : function (d) {
    return d[encode];
  };
}
export function valueof(data, encode) {
  return Array.from(data, field(encode));
}
export function initializeData(data, encode) {
  var _encode$source = encode.source,
    source = _encode$source === void 0 ? function (d) {
      return d.source;
    } : _encode$source,
    _encode$target = encode.target,
    target = _encode$target === void 0 ? function (d) {
      return d.target;
    } : _encode$target,
    _encode$value = encode.value,
    value = _encode$value === void 0 ? function (d) {
      return d.value;
    } : _encode$value;
  var links = data.links,
    nodes = data.nodes;
  var LS = valueof(links, source);
  var LT = valueof(links, target);
  var LV = valueof(links, value);
  return {
    links: links.map(function (_, i) {
      return {
        target: LT[i],
        source: LS[i],
        value: LV[i]
      };
    }),
    nodes: nodes || Array.from(new Set([].concat(_toConsumableArray(LS), _toConsumableArray(LT))), function (key) {
      return {
        key: key
      };
    })
  };
}
/**
 * @description Path need when the data is a flat json structure,
 * and the tree object structure do not need.
 */
export function generateHierarchyRoot(data, path) {
  if (Array.isArray(data)) {
    return typeof path === 'function' ? stratify().path(path)(data) : stratify()(data);
  }
  return hierarchy(data);
}